import { render, staticRenderFns } from "./GlobalPaginate.vue?vue&type=template&id=48de4809&scoped=true&"
import script from "./GlobalPaginate.vue?vue&type=script&lang=js&"
export * from "./GlobalPaginate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48de4809",
  null
  
)

export default component.exports